<script setup>
import {ref} from 'vue';
import {Dialog, DialogPanel, DialogTitle, TransitionRoot} from '@headlessui/vue';
import {useI18n} from 'vue-i18n';

const {t} = useI18n();

const props = defineProps({
  // Předvyplnění pro editaci; null = nový doklad
  id_card: {
    type: Object,
    required: false,
    default: () => ({
      id: null,
      id_card_type: null,
      id_card_number: null,
      id_card_issued_by: null,
      id_card_issue_date: null,
      id_card_validity: null,
      is_active: true,
    }),
  },
});

const idCard = ref({...props.id_card});

const isOpen = ref(true);
const emit = defineEmits(['confirm', 'cancel']);

const closeModalWith = (value) => {
  isOpen.value = false;
  setTimeout(() => {
    if (value === 'confirm') {
      emit('confirm', {...idCard.value});
    } else {
      emit('cancel');
    }
  }, 300);
};
</script>

<template>
  <TransitionRoot appear :show="isOpen" as="template">
    <Dialog as="div" class="modal show d-block" style="z-index: 1055;">
      <div class="modal-backdrop fade show"></div>
      <div class="modal-dialog modal-dialog-centered" style="z-index: 1055">
        <div class="modal-content">
          <DialogPanel class="modal-body p-4 rounded-lg shadow-lg">
            <div class="modal-header">
              <DialogTitle as="h3" class="modal-title">
                {{ idCard.id ? t('saveClientIdCardModal.title_edit') : t('saveClientIdCardModal.title_new') }}
              </DialogTitle>
              <i class="btn-close cursor-pointer" @click="closeModalWith('cancel')" aria-label="Close"></i>
            </div>
            <form @submit.prevent="closeModalWith('confirm')">
              <div class="modal-body">
                <div class="mb-3">
                  <label for="idCardTypeSelect" class="form-label">{{ t('saveClientIdCardModal.id_card_type') }}</label>
                  <select v-model="idCard.id_card_type" id="idCardTypeSelect" class="form-select form-control w-100">
                    <option :value="null">---</option>
                    <option value="ID_CARD">{{ t('clientsDetail.ID_CARD') }}</option>
                    <option value="PASSPORT">{{ t('clientsDetail.PASSPORT') }}</option>
                    <option value="DRIVING_LICENSE">{{ t('clientsDetail.DRIVING_LICENSE') }}</option>
                    <option value="BIRTH_CERTIFICATE">{{ t('clientsDetail.BIRTH_CERTIFICATE') }}</option>
                    <option value="BORN_DOCUMENT">{{ t('clientsDetail.BORN_DOCUMENT') }}</option>
                    <option value="RESIDENCE_PERMIT">{{ t('clientsDetail.RESIDENCE_PERMIT') }}</option>
                    <option value="OTHER">{{ t('clientsDetail.OTHER') }}</option>
                  </select>
                </div>
                <div class="mb-3">
                  <label for="idCardNumberInput" class="form-label">{{ t('saveClientIdCardModal.id_card_number') }}</label>
                  <input v-model="idCard.id_card_number" id="idCardNumberInput" class="form-control" type="text"/>
                </div>
                <div class="mb-3">
                  <label for="idCardIssuedByInput" class="form-label">{{ t('saveClientIdCardModal.id_card_issued_by') }}</label>
                  <input v-model="idCard.id_card_issued_by" id="idCardIssuedByInput" class="form-control" type="text"/>
                </div>
                <div class="mb-3">
                  <label for="idCardIssueDateInput" class="form-label">{{ t('saveClientIdCardModal.id_card_issue_date') }}</label>
                  <input v-model="idCard.id_card_issue_date" id="idCardIssueDateInput" class="form-control" type="date"/>
                </div>
                <div class="mb-3">
                  <label for="idCardValidityInput" class="form-label">{{ t('saveClientIdCardModal.id_card_validity') }}</label>
                  <input v-model="idCard.id_card_validity" id="idCardValidityInput" class="form-control" type="date"/>
                </div>
                <div class="mb-3">
                  <div class="form-check">
                    <input v-model="idCard.is_active" class="form-check-input" type="checkbox" id="idCardIsActiveCheckbox"/>
                    <label class="form-check-label" for="idCardIsActiveCheckbox">
                      {{ t('saveClientIdCardModal.is_active') }}
                    </label>
                  </div>
                </div>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-link text-decoration-underline text-dark" @click="closeModalWith('cancel')">
                  {{ t('saveClientIdCardModal.cancel') }}
                </button>
                <button class="btn btn-primary btn-sm" type="submit">
                  {{ t('saveClientIdCardModal.save') }}
                </button>
              </div>
            </form>
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>